import { render, staticRenderFns } from "./DialogAddress.vue?vue&type=template&id=c0cbdfe8&"
import script from "./DialogAddress.vue?vue&type=script&lang=js&"
export * from "./DialogAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports